module.exports = __webpack_public_path__ + "static/img/img1.c85e7a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/shop/img1.jpg
// module id = K6zg
// module chunks = 0